import React from "react";

const OffCanvas = ({
                       id,
                       title,
                       children,
                       placement = "end",
                       width = 400,
                       scroll = true,
                       backdrop = true,
                   }) => {
    return (
        <div
            className={`offcanvas offcanvas-${placement}`}
            data-bs-scroll={scroll}
            data-bs-backdrop={backdrop}
            tabIndex="-1"
            id={id}
            aria-labelledby={`${id}Label`}
            style={{width: width}}
        >
            <div className="offcanvas-header">
                <h5 className="offcanvas-title" id={`${id}Label`}>
                    {title}
                </h5>
                <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                ></button>
            </div>
            <div className="offcanvas-body">{children}</div>
        </div>
    );
};

export default OffCanvas;
